// extracted by mini-css-extract-plugin
export default {"textarea":"Style_textarea__IMX1J","errorMessage":"Style_errorMessage__wVM7d"};